import React, { useState } from "react";
import Courier from "../models/Courier";
import Order from "../models/Order";
import Product from "../models/Product";
import ProductCategory from "../models/ProductCategory";
import RestaurantInfos from "../models/RestaurantInfos";
import WorkingDays from "../models/WorkingDays";
import API from "../services";
import ProductsOption from "../models/ProductsOptions";
import buildEnv from "../build.env.json";


const defaultRestaurantId =
  buildEnv.BUILD_ENV == "PROD"
    ? "9fce979a-02f0-4156-b33d-9f2c215bf8cf" //HappyB
    : "f8edcd4e-e195-4285-96ae-b65e3ccb89d3";

const RestaurantDataContext = React.createContext({
  isInit: false,
  restaurantId: "",
  restaurantFound: false,
  setRestaurantIdHandler : (restaurantId : string) => {},
  productCategoriesList: [] as ProductCategory[],
  productsList: [] as Product[],
  productsOptionsList: [] as ProductsOption[],
  initRestaurantData: (restaurantId : string) => {},
  restaurantInfos: {} as RestaurantInfos,
  workingDays: {} as WorkingDays,
});

export const RestaurantDataContextProvider: React.FC = (props) => {
  const [isInit, setIsInit] = useState(false);
  const [restaurantFound, setRestaurantFound] = useState(false);
  const [restaurantInfos, setRestaurantInfos] = useState({} as RestaurantInfos);
  const [productCategoriesList, setProductCategoriesList] = useState(
    [] as ProductCategory[]
  );

  //Working days
  const [workingDays, setWorkingDays] = useState({} as WorkingDays);

  const [restaurantId, setRestaurantId] =
    useState(defaultRestaurantId);

  const [productsList, setProductsList] = useState([] as Product[]);
  const [productsOptionsList, setProductsOptionsList] = useState(
    [] as ProductsOption[]
  );

  const setRestaurantIdHandler = (restaurantId: string) => {
    setRestaurantId(restaurantId);
  };

  const initRestaurantData = async (restaurantId : string) => {
    console.log(restaurantId);
    if(restaurantId){

      API.getRestaurantData(restaurantId)
      .then((data) => {
        
        //console.log(data);
        setRestaurantInfos(data.restaurantInfos);
        setProductsList(data.products);
        setProductCategoriesList(data.productCategories);
        setProductsOptionsList(data.productsOptions);
        setWorkingDays(data.workingDays);
        setIsInit(true);
      })
      .catch((e) => {
        console.log(e);
      });
    }
    
  };

  return (
    <RestaurantDataContext.Provider
      value={{
        isInit,
        restaurantId,
        restaurantFound,
        setRestaurantIdHandler,
        productCategoriesList,
        productsList,
        productsOptionsList,
        initRestaurantData,
        restaurantInfos,
        workingDays
      }}
    >
      {props.children}
    </RestaurantDataContext.Provider>
  );
};

export default RestaurantDataContext;
